module.exports = __webpack_public_path__ + "resource/img/image021Dark.0b7e979f.png";